<template>
  <v-dialog
    :value="isInfoDialogOpen"
    max-width="800px"
    persistent
  >
    <v-card class="pa-4">
      <div class="d-flex flex-row-reverse mr-2">
        <v-btn
          icon
          small
          @click="closeDialog"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-title class="justify-center text-h5">
        {{ edit ? 'Editar' : 'Criar' }} Pergunta
      </v-card-title>

      <v-card-text class="mt-8">
        <v-form
          ref="form"
          v-model="valid"
          class="multi-col-validation"
          @submit.prevent="handleSubmit"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="faqData.pergunta"
                dense
                outlined
                label="Pergunta"
                hide-details="auto"
                :rules="[validators.required]"
              />
            </v-col>

            <v-col cols="12">
              <template>
                <div>
                  <tiptap-vuetify
                    v-model="faqData.resposta"
                    class="resposta"
                    :extensions="extensions"
                  />
                </div>
              </template>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              class="d-flex justify-center"
            >
              <v-btn
                color="primary"
                class="mr-3"
                type="submit"
              >
                <v-progress-circular
                  v-if="loading"
                  class="mx-3"
                  indeterminate
                  color="secundary"
                />

                <span v-else>{{ edit ? 'Editar' : 'Criar' }}</span>
              </v-btn>

              <v-btn
                color="secondary"
                class="mb-1"
                outlined
                type="reset"
                @click="closeDialog"
              >
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style>
.resposta img{
  width: 400px;
  position: relative;
}
</style>

<script>
import { required } from '@core/utils/validation'
import { mdiClose } from '@mdi/js'
import { ref, watch } from '@vue/composition-api'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
  Image,
} from 'tiptap-vuetify'

import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import FaqService from '@/services/modules/FaqService'

export default {
  components: { TiptapVuetify },

  props: {
    items: {
      type: Object,
      default: () => {},
    },
    isInfoDialogOpen: {
      type: Boolean,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
    },
  },

  data: () => ({
    extensions: [
      Blockquote,
      [Link, {
        options: {
          target: '_blank',
        },
      }],
      Underline,
      Strike,
      Italic,
      ListItem,
      BulletList,
      OrderedList,
      [Heading, {
        options: {
          levels: [1, 2, 3],
        },
      }],
      Bold,
      Code,
      HorizontalRule,
      Paragraph,
      HardBreak,
      History,
      Image,
    ],

    content: `
      <h1>Yay Headlines!</h1>
      <p>All these <strong>cool tags</strong> are working now.</p>
    `,
  }),

  setup(props, { emit }) {
    const faqData = ref({
      pergunta: '',
      resposta: '',
    })
    const faqBlank = ref({
      pergunta: '',
      resposta: '',
    })

    const form = ref(null)
    const valid = ref(false)
    const loading = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const closeDialog = () => {
      emit('update:isInfoDialogOpen', false)
      faqData.value = faqBlank.value
      resetForm()
    }

    watch(
      () => props.isInfoDialogOpen,
      () => {
        if (props.edit) {
          faqData.value.id = props.items.id
          faqData.value.topicoId = props.items.topicoId
          faqData.value.pergunta = props.items.pergunta
          faqData.value.resposta = props.items.resposta
        } else {
          faqData.value = faqBlank.value
          faqData.value.resposta = ''
          faqData.value.topicoId = props.items.id
        }
      },
    )

    const handleSubmit = async () => {
      if (!faqData.value.resposta.trim()) {
        Vue.$toast.warning('Para salvar, necessário preencher o campo de repostas.')
        return
      }

      if (valid.value) {
        try {
          loading.value = true

          if (props.edit) {
            await FaqService.atualizarPerguntaResposta(faqData.value)
          } else {
            await FaqService.criarPerguntaResposta(faqData.value)
          }

          loading.value = false
          emit('refetch-data')
          closeDialog()
        } catch (error) {
          loading.value = false
        }
      } else {
        validate()
      }
    }

    return {
      faqData,
      form,
      valid,
      loading,
      faqBlank,
      closeDialog,
      handleSubmit,
      validate,
      validators: {
        required,
      },
      icons: {
        mdiClose,
      },
    }
  },
}
</script>
